import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/apis";

export const base_url_2 = "https://digi.pmpframe.com/";

export const get_background_image = createAsyncThunk(
  "background",
  async (id) => {
    try {
      const body = new FormData();
      body.append("action", "list");
      body.append("type", "web");
      //   body.append("userid", user.userid);
      const response = await fetch(base_url + "image.php", {
        method: "POST",
        //     credentials: "include",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body: body,
      });
      const res = await response.json();
      return res;
    } catch (error) {}
  }
);
export const get_video = createAsyncThunk("video", async (_, thunkAPI) => {
  try {
    const body = new FormData();
    body.append("action", "list");
    // body.append("role", "superadmin");

    const url = "https://security.insugo.in/api/video.php";
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      // headers: {
      //   "Content-Type": "application/json",
      // },
      body: body,
    });

    // Helpful debug info for diagnosing 401 vs Postman behaviour
    // console.log("[get_video] URL:", url);
    // console.log("[get_video] response.status:", response.status);
    // try to read a few headers (CORS, set-cookie etc) if present
    try {
      // console.log(
      //   "[get_video] response.headers.get('access-control-allow-origin'):",
      //   response.headers.get("access-control-allow-origin")
      // );
      // console.log(
      //   "[get_video] response.headers.get('set-cookie'):",
      //   response.headers.get("set-cookie")
      // );
    } catch (e) {
      // some browsers restrict reading certain headers; ignore errors
    }

    const res = await response.json();
    // console.log("[get_video] response body:", res);

    // In dev, also compare what happens if credentials are not sent — useful to distinguish
    // whether the server expects a cookie/session or treats public calls differently.
    if (process.env.NODE_ENV === "development" && response.status === 401) {
      try {
        const r2 = await fetch(url, { method: "POST", body });
        console.log(
          "[get_video] (dev) response without credentials status:",
          r2.status
        );
        const r2body = await r2.json();
        console.log(
          "[get_video] (dev) response without credentials body:",
          r2body
        );
      } catch (e) {
        console.error("[get_video] (dev) fetch without credentials failed:", e);
      }
    }

    return res;
  } catch (error) {
    console.error("[get_video] fetch error:", error);
    return thunkAPI.rejectWithValue(error?.message ?? "Unknown error");
  }
});

export const get_alerts = createAsyncThunk("alerts", async (id) => {
  const body = new FormData();

  body.append("action", "userlist");
  body.append("cus_id", id);
  const response = await fetch(base_url + "alert-message.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  return res;
});

const otherSlice = createSlice({
  name: "claim",
  initialState: {
    background_img: "",
    video_list: [],
    alerts_list: [],
  },
  extraReducers: (builder) => {
    builder.addCase(get_background_image.fulfilled, (state, action) => {
      const data = action.payload;
      if (!data) {
        console.log("No data found for background image");
        return;
      }
      if (data.success) {
        const filterData = data?.data?.filter((v, i) => v?.Status == "1");
        state.background_img = filterData[0]?.Img_url;
      } else {
        state.background_img = "";
      }
    });
    builder.addCase(get_video.fulfilled, (state, action) => {
      const data = action.payload;
      if (data.success) {
        state.video_list = data.data;
      } else {
        state.video_list = [];
      }
    });
    builder.addCase(get_alerts.fulfilled, (state, action) => {
      const data = action.payload;
      if (data.success) {
        state.alerts_list = data.data;
      } else {
        state.alerts_list = [];
      }
    });
  },
});
export default otherSlice.reducer;
